/**
 * Converts degrees to radians
 * @param degrees - The angle in degrees
 * @returns The angle in radians
 */
export const ToRadians = (degrees: number): number => degrees * (Math.PI / 180)
